<script lang="ts">
  import PoweredBy from 'src/components/powered-by.svelte';
  import ReviewCard from 'src/components/ReviewCard.svelte';
  import Swipe from 'src/components/Swipe.svelte';
  import type { BusinessReviewEntry } from 'src/function-utils/data-models';
  import { floatingWidgetSettingsStore } from 'src/stores/floating-widget-settings-store';
  import {
    trackOpenSmallCard,
    trackSeeSmallCardPage,
  } from 'src/utils/telemetry';
  import NavBtn from './NavBtn.svelte';

  const businessKey = $floatingWidgetSettingsStore.businessKey;
  trackOpenSmallCard('default', businessKey);

  export let reviews: BusinessReviewEntry[];
  export let isFetchingReviews: boolean = false;

  export let index = 0;
  let swipeContainer: Swipe;

  export function nextReview() {
    swipeContainer.next();
  }

  function previousReview() {
    swipeContainer.prev();
  }

  $: {
    trackSeeSmallCardPage('default', businessKey, index);
  }

  $: disableNext = index >= reviews.length - 1;
  $: showNavBtnLoading = isFetchingReviews && disableNext;
</script>

<div class="container {$$restProps.class || ''}">
  <div class="card rounded-borders shadow-2">
    <Swipe
      numScreens={reviews.length}
      bind:this={swipeContainer}
      bind:current={index}
      let:progress
      class="reviewContainer"
    >
      {#each reviews as review, i}
        <div class="reviewBodyWrapper" style="right: {100 * (progress - i)}%">
          {#if Math.abs(i - index) <= 1}
            <ReviewCard
              rating={review.rating}
              ratingMax={review.ratingMax}
              recommended={review.recommended}
              user={review.authorEmbedded}
              reviewType={review.type}
              message={review.message}
              date={review.ts}
              reviewOriginUrl={review.reviewOriginUrl}
              {businessKey}
              style="right: {100 * (progress - i)}%"
              class="reviewCard"
            />
          {/if}
        </div>
      {/each}
    </Swipe>

    <PoweredBy class="poweredBy" />
  </div>

  {#if reviews.length > 1}
    <NavBtn
      direction="left"
      class="leftBtn shadow-2"
      disabled={index === 0}
      on:click={previousReview}
    />
    <NavBtn
      direction="right"
      class="rightBtn shadow-2"
      disabled={disableNext}
      loading={showNavBtnLoading}
      on:click={nextReview}
    />
  {/if}
</div>

<style lang="scss">
  @import '../../../stylesheets/variables.scss';

  $height: 260px;
  $width: 300px;

  $navBtnShift: -12px;
  $navBtnShiftMobile: -18px;

  $topBtnSize: 20px;

  .container {
    > :global(.leftBtn) {
      position: absolute;
      left: $navBtnShift;
      top: 50%;
      z-index: 200;
      transform: translateY(-50%);
    }

    > :global(.rightBtn) {
      position: absolute;
      right: $navBtnShift;
      top: 50%;
      z-index: 200;
      transform: translateY(-50%);
    }
  }

  @media screen and (max-width: $breakpoint-xs) {
    .container {
      > :global(.leftBtn) {
        left: $navBtnShiftMobile;
      }

      > :global(.rightBtn) {
        right: $navBtnShiftMobile;
      }
    }
  }

  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: $width;
    height: $height;
    border-radius: 8px;
    background-color: white;
    overflow: hidden;
  }

  :global(.reviewContainer) {
    overflow-x: hidden;

    .reviewBodyWrapper {
      overflow-y: auto;
      position: absolute;
      width: 100%;
      height: 100%;
      touch-action: pan-y;
    }

    :global(.reviewCard) {
      padding: 12px 24px;
      width: 100%;
      min-height: 100%;
    }
  }

  .topBar {
    display: flex;
    justify-content: flex-end;
    padding: 4px 8px;
  }

  .minimizeBtn {
    width: $topBtnSize;
    height: $topBtnSize;
    padding: 4px;
    cursor: pointer;
  }

  :global(.poweredBy) {
    background: var(--light-3);
    padding: 4px;
  }
</style>
